/* unplugin-vue-components disabled */import script from "./RoleStatusCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleStatusCard.vue?vue&type=script&setup=true&lang=js"

import "./RoleStatusCard.vue?vue&type=style&index=0&id=427f47e4&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-427f47e4"]])

export default __exports__